import * as types from '../mutation-types'
import { ajaxFun } from '../actions'

// initial state
const state = {
  all: [],
  flag: false,
  time: '',
  topInfo: {},
  topFlag: false,
  topTime: ''
}

// getters
const getters = {
  getTopInfos: state => state.topInfo
}

// actions
const actions = {
  receiveTopInfos ({ commit, state }, para) {
    ajaxFun({commit, state}, para, state.topFlag, state.topTime, types.RECEIVE_TOPINFOS)
  }
}

// mutations
const mutations = {
  [types.RECEIVE_TOPINFOS] (state, info) {
    state.topInfo = info
    state.topFlag = true
    state.topTime = new Date().getTime()
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./C:/vue/2.0/src/vuex/modules/information.js